import React, { useCallback, useRef, useState } from 'react';
import * as S from './Styled';
import { useTranslation } from 'react-i18next';
import useOnClickOutside from '../../../../hooks/useOnClickOutside';
import { useAccessibility } from '../../../AccessibilityToolbar';
import EyeIcon from '../../../AccessibilityToolbar/EyeIcon';

const UserMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { toggleToolbar } = useAccessibility();

  const closeDropdown = useCallback(() => setOpen(false), []);
  useOnClickOutside(ref, closeDropdown);

  const items = (
    <>
      <S.NavItem to="/#about" onClick={() => setOpen(false)}>
        {t('labels.about')}
      </S.NavItem>
      <S.NavItem to="/drugstores" onClick={() => setOpen(false)}>
        {t('labels.network_of_drugstores')}
      </S.NavItem>
      <S.NavItem to="/promotions" onClick={() => setOpen(false)}>
        {t('labels.promotions')}
      </S.NavItem>
      <S.NavButton
        onClick={() => { toggleToolbar(); setOpen(false); }}
        title={t('accessibilityToolbar.toggle')}
      >
        <EyeIcon />
      </S.NavButton>
    </>
  );

  return (
    <>
      <S.NavCollapsed ref={ref}>
        <S.NavToggle onClick={() => setOpen(v => !v)} aria-expanded={open}>
          {t('labels.menu')}
          <S.NavToggleArrow>▾</S.NavToggleArrow>
        </S.NavToggle>
        {open && <S.Dropdown>{items}</S.Dropdown>}
      </S.NavCollapsed>
      <S.Nav>{items}</S.Nav>
    </>
  );
};

export default UserMenu;